import styled from 'styled-components';
import theme from 'styles/theme';

export const ModalContainer = styled.div`
  span.green {
    color: ${theme.colors.fontGreen};
  }

  .subCheckbox {
    margin-left: 20px;
  }
`;

export const ModalFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
